import classNames from 'classnames/bind';
import React, { Component } from 'react';
import { isTablet } from 'react-device-detect';
import SNavigationBar from 'shared/components/NavigationBar';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import Utils from 'shared/utils/index';
import { TooltipTypes } from 'shared/utils/tooltipConstants';
import styled, { ThemeContext } from 'styled-components';
import { pwaStyleAdapter } from '../../utils/mobileSupported';
import CurrencyDisplay from '../CurrencyDisplay';
import LevelBar from '../LevelBar';
import MissionsProgressTopBar from '../MissionsProgress';
import Tier from '../Tier';
import Home from './components/Home';
import SettingsMenu from './components/SettingsMenu';
import MiddleSeciton from './components/MiddleSeciton';
import PiggyBankWidget from './components/PiggyBankWidget';

export default class NavigationBar extends Component {
  _getNavStateAnimationClassName = shouldShowCoinBalance => {
    return shouldShowCoinBalance ? 'AnimationGoLobby' : 'AnimationGoInGame';
  };

  _getCurrencyContainerWidth = currency => {
    const currencyDigits = currency?.toString()?.length;
    if (!currencyDigits || currencyDigits < 7) return 200;
    return currencyDigits < 8 ? currencyDigits * 32 : currencyDigits < 15 ? currencyDigits * 29 : currencyDigits * 24;
  };

  render() {
    const themeContext = this.context;

    return (
      <SNavigationBar
        {...this.props}
        render={
          /**
            @param {Object} args
            @param {import('shared/api/Constants').DTS} args.dts
           */
          args => {
            const {
              IapButtonState,
              limitedTimeOffer,
              coins,
              loyalty,
              showModal,
              navigateBack,
              showCoinBalance,
              isHome,
              isMissions,
              isBattles,
              showActiveTracker,
              changeTooltipType,
              tooltipType,
              ftueStep,
              showLinkLoyaltyCardSetting,
              showHomeButton,
              tooltipDetails,
              shouldShowTooltip,
              showMissionsProgressBar,
              rewardCenterMiddleware,
              isBlockedForMissionsTutorial,
              showPiggyBankWidget,
            } = args;

            const checkLoyaltyBarWidth = () => {
              if (showLinkLoyaltyCardSetting) {
                return showActiveTracker ? '7vmin' : '20vw';
              } else {
                return showActiveTracker ? '7vmin' : 1000;
              }
            };

            return (
              <div
                className="navBar"
                style={{
                  ...pwaStyleAdapter(themeContext.NavigationBar.TopBar),
                  pointerEvents: isBlockedForMissionsTutorial ? 'none' : 'auto',
                }}
              >
                <Backing />

                <div style={themeContext.NavigationBar.BarSection}>
                  {/* left */}
                  <FlexBarSection className="flexBarSection">
                    {/* Home Icon */}
                    <Home
                      showHomeButton={showHomeButton}
                      navigateBack={navigateBack}
                      isHome={isHome}
                      ftueStep={ftueStep}
                      themeContext={themeContext}
                      getNavStateAnimationClassName={this._getNavStateAnimationClassName}
                    />

                    {/* Coins Bar */}
                    <div
                      style={{
                        ...themeContext.NavigationBar.CoinsCurrencyContainer,
                        display: showCoinBalance ? 'flex' : 'none',
                      }}
                    >
                      <CurrencyDisplay
                        source={assetSource(ASSET_KEY.COIN_ICON)}
                        ibw={require(asset`images/top-bar-assets/coin-icon.ibw`)}
                        manualAssetScale={3}
                        style={{
                          paddingRight: '1rem',
                          maxWidth: null,
                          flex: '1 1 50%',
                        }}
                        imgStyle={{
                          height: 55,
                          width: 65,
                          left: -27,
                          top: -14,
                        }}
                        value={coins}
                        iconType="coins"
                        changeTooltipType={changeTooltipType}
                        tooltipType={tooltipType}
                        currencyType={TooltipTypes.COINS}
                        containerWidth={this._getCurrencyContainerWidth(coins)}
                        containerHeight={80}
                        additionalWrapperClassNames={this._getNavStateAnimationClassName(showCoinBalance || isMissions)}
                        isCoinsGlowAnimationStopped={this.props.isCoinsGlowAnimationStopped}
                        isCoinsGlowAnimationEnabled={this.props.isCoinsGlowAnimationEnabled}
                        showLinkLoyaltyCardSetting={showLinkLoyaltyCardSetting}
                        showPiggyBankWidget={showPiggyBankWidget}
                      />
                    </div>

                    {/* Piggy Bank Widget */}
                    {showPiggyBankWidget && <PiggyBankWidget showCoinBalance={showCoinBalance} />}

                    {/* Level Bar */}
                    <div
                      className={`LevelBarWrapper ${this._getNavStateAnimationClassName(showCoinBalance)}`}
                      style={{
                        flex: '1 1 50%',
                        height: '100%',
                        flexDirection: 'row',
                        paddingHorizontal: '2%',
                      }}
                    >
                      <LevelBar
                        style={{
                          position: 'relative',
                          flex: 1,
                          justifyContent: Utils.ieVersion() !== 0 ? 'flex-start' : 'center',
                          maxWidth: '100%',
                        }}
                        navigation={this.props.navigation}
                        changeTooltipType={changeTooltipType}
                        tooltipType={tooltipType}
                        shouldShowCoinBalance={showCoinBalance}
                      />
                    </div>
                  </FlexBarSection>
                  {/* middle */}
                  <MiddleSeciton
                    limitedTimeOffer={limitedTimeOffer}
                    IapButtonState={IapButtonState}
                    showModal={showModal}
                  />
                  {/* right */}
                  <FlexBarSection className={classNames('flexBarSection', { mission: showMissionsProgressBar })}>
                    <CurrencyDisplay
                      source={assetSource(ASSET_KEY.LOYALTY_ICON)}
                      ibw={require(asset`images/top-bar-assets/loyalty-icon.ibw`)}
                      manualAssetScale={3}
                      style={{
                        maxWidth: checkLoyaltyBarWidth(),
                        paddingRight: '1rem',
                        ...(!showMissionsProgressBar && { ...themeContext.NavigationBar.LoyaltyBarContainer }),
                        ...(showMissionsProgressBar && {
                          ...(showLinkLoyaltyCardSetting
                            ? { ...themeContext.NavigationBar.LoyaltyCurrencyWrapperStyle }
                            : { ...themeContext.NavigationBar.LoyaltyCurrencyWrapperStyleWithoutCard }),
                        }),
                        ...(showActiveTracker && !showMissionsProgressBar && { left: 25 }),
                      }}
                      imgStyle={{
                        ...themeContext.NavigationBar.LoyaltyCurrencyIconStyle,
                        ...(showMissionsProgressBar
                          ? themeContext.NavigationBar.LoyaltyCurrencyIconStyleWithMissionsbar
                          : {}),
                      }}
                      value={loyalty}
                      iconType="loyalty"
                      enableOnClick={true}
                      onClick={rewardCenterMiddleware}
                      imageOnly={showMissionsProgressBar}
                      changeTooltipType={changeTooltipType}
                      tooltipType={tooltipType}
                      currencyType={TooltipTypes.LOYALTY}
                      containerWidth={this._getCurrencyContainerWidth(loyalty)}
                      containerHeight={80}
                      innerStyle={{ paddingLeft: 15 }}
                      showLinkLoyaltyCardSetting={showLinkLoyaltyCardSetting}
                    />

                    {showMissionsProgressBar && (
                      <MissionsProgressTopBar
                        showLinkLoyaltyCardSetting={showLinkLoyaltyCardSetting}
                        tooltipDetails={tooltipDetails}
                        shouldShowTooltip={shouldShowTooltip}
                        navigation={this.props.navigation}
                        isMissionsScreen={isMissions}
                        isBattlesScreen={isBattles}
                      />
                    )}

                    {showLinkLoyaltyCardSetting && (
                      <Tier
                        showMissionsProgressBar={showMissionsProgressBar}
                        navigation={this.props.navigation}
                        showActiveTracker={showActiveTracker}
                        changeTooltipType={changeTooltipType}
                        tooltipType={tooltipType}
                      />
                    )}

                    <SettingsMenu showModal={showModal} themeContext={themeContext} />
                  </FlexBarSection>
                </div>
              </div>
            );
          }
        }
      />
    );
  }
}

NavigationBar.contextType = ThemeContext;

const FlexBarSection = styled.div`
  flex: 1;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  ${!isTablet &&
  `padding-left: 1rem;
    padding-right: 1rem;`}
`;

const Backing = styled.div`
  background-image: url(${assetSource(ASSET_KEY.TOP_BAR_ASSETS_BACKING)});
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: -100;
  background-size: 100% 100%;
`;
